import React, { useEffect, useState } from "react";
import { DatePicker, Table, Checkbox, Button, Modal } from "antd";
import { renderToStaticMarkup } from "react-dom/server";
import LoadingSpinner from "Components/UI/LoadingSpinner";
import { useTableSearch } from "core/Operations/useTableSearch";
import Error404 from "MainPages/ErrorPages/error404";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { Edit, Eye, PlusCircle, RefreshCcw, RefreshCw } from "react-feather";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { all_routes } from "Router/all_routes";
import { useSelector } from "react-redux";
import { loggedInUser } from "core/redux/slice/authSlice";
import TableTop from "Components/UI/TableTop";
import { format } from "date-fns";

import { useGetEmployeeQuery } from "AppQuries/employee/employee_list";

import ReportTools from "Components/UI/ReportTools";
import MonthOption from "Components/Form/MonthSelect";
import YearOption from "Components/Form/YearSelect";
import autoTable from "jspdf-autotable";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import Payslip from "Components/UI/Payslip/Payslip";
import {
  useGetPayrollStagingListQuery,
  useReCalculateSalaryMutation,
  useUpdatePaymentDateMutation,
} from "AppQuries/payroll/staging";
import { useSavePayrollMutation } from "AppQuries/payroll/save-payroll";
import Swal from "sweetalert2";
import { useFormattedEmployees } from "core/Operations/formattedOption/useFormattedEmployeeOptions";
import { useReGeneratePayrollMutation } from "AppQuries/payroll/generate-payroll";
import Can from "core/Operations/Can";
import { accessCodes } from "core/json/accessCode";
import dayjs from "dayjs";
import ChangeDate from "Components/Modal/change-date";
import { salaryUpdateReGenerateValidation } from "core/Operations/ValidationSchema/payrollValidation";
import { useForm } from "react-hook-form";
import EditAdditionDeductionModal from "./payroll/staging/EditAdditionDeductionModal";
import StagingPayDate from "./payroll/staging/StagingPayDate";
const dateFormat = "YYYY-MM-DD";
const PayrollStaging = () => {
  const userData = useSelector(loggedInUser);
  const [searchParams, setSearchParams] = useSearchParams();

  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [selectedPayslip, setSelectedPayslip] = useState(null);
  const [tempBasicSalary, setTempBasicSalary] = useState({});
  const [tempMonthSalary, setTempMonthSalary] = useState({});
  const [tempDaySalary, setTempDaySalary] = useState({});
  const [showEditModal, setShowEditModal] = useState(false);
  const [editModalId, setEditModalId] = useState(0);
  const [editModalRefNo, setEditModalRefNo] = useState(0);

  const [isModalVisible, setIsModalVisible] = useState(false);
  const [companyDetails, setCompanyDetails] = useState({
    ...userData,
  });

  const [reportData, setReportData] = useState([]);
  const { register, handleSubmit, setValue, setValueAs } = useForm({
    defaultValues: {
      reportData: reportData, // array of objects
    },
  });

  const navigate = useNavigate();
  const [filter, setFilter] = useState({
    month:
      searchParams.get("month") ||
      String(new Date().getMonth()).padStart(2, "0"),
    year: searchParams.get("year") || format(new Date(), "yyyy"),
    companyCode: userData.companyCode,
    locationCode: userData.selectedLocationCode,
  });

  const monthSelectHandler = (e) => {
    setFilter((prev) => {
      return {
        ...prev,
        month: e,
      };
    });
  };

  const yearSelectHandler = (e) => {
    setFilter((prev) => {
      return {
        ...prev,
        year: e,
      };
    });
  };
  const [employeeCode, setEmployeeCode] = useState(0);

  const {
    data,
    isFetching,
    isError,
    error,
    refetch: getReport,
  } = useGetPayrollStagingListQuery(
    {
      ...filter,
      employeeCode: employeeCode,
    },
    {
      enabled: !!filter.month && !!filter.year && !!filter.companyCode,
    },
  );

  useEffect(() => {
    if (!data?.employeeHeader) return;

    const formatted = data.employeeHeader.map((d, index) => ({
      ...d,
      id: index,
      key: index,
      processMonth: `${format(
        new Date(d.processYear, d.procesMonth - 1, 1),
        "MMM",
      )}-${d.processYear}`,
    }));

    setReportData(formatted);
  }, [data]);

  const handleRefresh = () => {
    getReport();
  };

  const {
    mutate: regeneratePayrollData,
    isLoading,
    isError: isRegenerateError,
    error: regenerateError,
  } = useReGeneratePayrollMutation();

  const employeeOptions = useFormattedEmployees({
    companyCode: userData?.companyCode,
    locationCode: userData?.selectedLocationCode,
    departmentCode: 0,
  });

  const { mutate: updatePaymentDate, isPending: isUpdatePending } =
    useUpdatePaymentDateMutation();

  const {
    mutate: payrollApprove,
    isError: ispayrollApproveError,
    error: payrollApproveError,
    isPending,
  } = useSavePayrollMutation();
  const [isFilterVisible, setIsFilterVisible] = useState(false);

  const toggleFilterVisibility = () => {
    setIsFilterVisible((prevVisibility) => !prevVisibility);
  };

  const handleSelect = (record, selected) => {
    if (selected) {
      setSelectedRowKeys((keys) => [...keys, record.key]);
    } else {
      setSelectedRowKeys((keys) => {
        const index = keys.indexOf(record.key);
        return [...keys.slice(0, index), ...keys.slice(index + 1)];
      });
    }
  };

  const toggleSelectAll = () => {
    setSelectedRowKeys((keys) =>
      keys.length === reportData.length ? [] : reportData.map((r) => r.key),
    );
  };

  const headerCheckbox = (
    <Checkbox
      checked={selectedRowKeys.length}
      indeterminate={
        selectedRowKeys.length > 0 && selectedRowKeys.length < reportData.length
      }
      style={{ zIndex: "unset" }}
      onChange={toggleSelectAll}
    />
  );

  const rowSelection = {
    selectedRowKeys,
    type: "checkbox",
    fixed: true,
    onSelect: handleSelect,
    columnTitle: headerCheckbox,
    //onSelectAll: this.handleSelectAll
  };

  const showModal = () => {
    setIsModalVisible(true);
  };

  const showEditHandler = (record) => {
    setEditModalId(record.id);
    setEditModalRefNo(record.refNo);
    setShowEditModal(true);
  };

  const closeEditModal = () => {
    setShowEditModal(false);
    setEditModalId(0);
    setEditModalRefNo(0);
  };
  const handleCancel = () => setIsModalVisible(false);

  const downloadPayslip = () => {
    const doc = new jsPDF();
    doc.text("Payslip Report", 20, 20);
    autoTable(doc, { html: "#payslip-table" });
    doc.save(
      `Payslip-${selectedPayslip?.fullName}-${filter.month}-${filter.year}.pdf`,
    );
  };

  const updatePayDate = (date, record, index) => {
    console.log(date, record, index);
    setReportData((prev) =>
      prev.map((item, i) =>
        i === index
          ? {
              ...item,
              paymentDate: date ? dayjs(date).format(dateFormat) : "",
            }
          : item,
      ),
    );
  };

  const [showPaymentDateModal, setShowPaymentDateModal] = useState(false);
  const [payDate, setPayDate] = useState(null);

  const changePayDate = () => {
    Swal.fire({
      title: "Confirm to change pay date?",
      text: "Are you sure you want to change pay date",
      type: "warning",
      showCancelButton: !0,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, change it!",
      confirmButtonClass: "btn btn-primary",
      cancelButtonClass: "btn btn-danger",
      customClass: {
        popup: "my-swal-popup",
      },

      // buttonsStyling: !1,
      // reverseButtons: !0,
    }).then(function (t) {
      if (t.isConfirmed) {
        const payload = {
          companyCode: userData?.companyCode,
          paymentDate: payDate ? dayjs(payDate).format(dateFormat) : "",
          refNo: reportData
            .filter((item) => selectedRowKeys.includes(item.key))
            .map((item) => item.refNo),
        };

        console.log("payload", payload);

        updatePaymentDate(payload, {
          onSuccess: (response) => {
            if (response?.response === true) {
              Swal.fire({
                type: "success",
                title: "Payment Date Updated",
                text: response?.errorMessage,
                confirmButtonClass: "btn btn-success",
              }).then(function (t) {
                const updatedData = reportData.map((item) => {
                  if (selectedRowKeys.includes(item.key)) {
                    return {
                      ...item,
                      paymentDate: payDate
                        ? dayjs(payDate).format(dateFormat)
                        : "",
                    };
                  }
                  return item;
                });
                setReportData(updatedData);
              });
            } else {
              Swal.fire({
                title: "Warning!",
                text: response?.errorMessage,
                type: "warning",
                confirmButtonColor: "#3085d6",
                confirmButtonText: "Ok",
                confirmButtonClass: "btn btn-primary",
                okButtonClass: "",
                buttonsStyling: 1,
              });
            }
          },
        });
      }
    });
  };

  const updateRowInState = (index, updatedRow) => {
    updatedRow.key = index;
    setReportData((prev) =>
      prev.map((row) =>
        row.key === updatedRow.key ? { ...row, ...updatedRow } : row,
      ),
    );
  };

  // const updateRowInForm = (index, updatedRow) => {
  //   Object.keys(updatedRow).forEach((key) => {
  //     setValue(`payrollData[${index}].${key}`, updatedRow[key]);
  //   });
  // };

  const regeneratePayroll = ({
    companyCode,
    refNo,
    month,
    year,
    userCode,
    locationCode,
    salaryType,
    employeeCode,
  }) => {
    if (
      !companyCode ||
      !refNo ||
      !month ||
      !year ||
      !userCode ||
      !locationCode ||
      !salaryType ||
      !employeeCode
    ) {
      Swal.fire({
        title: "Warning!",
        text: "Something went wrong. Please try again",
        type: "warning",
        confirmButtonColor: "#3085d6",
        confirmButtonText: "Ok",
        confirmButtonClass: "btn btn-primary",
        okButtonClass: "",
        buttonsStyling: 1,
      });
    } else {
      Swal.fire({
        title: "Confirm to regenerate?",
        text: "Are you sure you want re-regenerate payroll",
        type: "warning",
        showCancelButton: !0,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, submit it!",
        confirmButtonClass: "btn btn-primary",
        cancelButtonClass: "btn btn-danger ml-1",
        buttonsStyling: 1,
        buttons: ["No", "Yes"],
      }).then(function (t) {
        if (t.isConfirmed) {
          const payload = {
            companyCode,
            refNo,
            month,
            year,
            userCode,
            locationCode,
            salaryType,
            employeeCode,
          };
          regeneratePayrollData(payload, {
            onSuccess: (response) => {
              if (response[0].response === true) {
                Swal.fire({
                  type: "success",
                  title: "Payroll Re-Generated!",
                  text: "Payroll Re-Generated Successfully..",
                  confirmButtonClass: "btn btn-success",
                }).then(function (t) {
                  // navigate(`${all_routes.payroll}${all_routes.payroll_stage}`);
                  handleRefresh();
                });
              } else {
                Swal.fire({
                  title: "Warning!",
                  text: response[0].errorMessage,
                  type: "warning",
                  confirmButtonColor: "#3085d6",
                  confirmButtonText: "Ok",
                  confirmButtonClass: "btn btn-primary",
                  okButtonClass: "",
                  buttonsStyling: 1,
                });
              }
            },
          });
        }
      });
    }
  };

  const {
    mutate: reCalculateSalaryMutate,
    isPending: isReCalculatePending,
    isError: isReCalculateError,
    error: reCalculateError,
  } = useReCalculateSalaryMutation();

  const reCalculateSalary = async (record, salary) => {
    // console.log("record", record);
    // console.log("userData", userData);
    // const salary = record?.updatedBasicSalary || 0;

    // record?.salaryType === "Monthly"
    //   ? record?.basicSalary
    //   : record?.salaryType === "Hourly"
    //     ? record?.hourlySalary
    //     : record?.salaryType === "Daily"
    //       ? record?.daySalary
    //       : 0;
    let payload = {
      companyCode: record?.companyCode,
      locationCode: record?.locationCode,
      month: record?.procesMonth?.toString(),
      year: record?.processYear?.toString(),
      userCode: userData?.userID,
      salaryType: record?.salaryType,
      employeeCode: record?.employeeCode,
      basicSalary: Number(salary) || 0, //salary,
    };

    setTempMonthSalary({});

    try {
      await salaryUpdateReGenerateValidation.validate(payload);
    } catch (err) {
      Swal.fire({
        title: "Warning!",
        text: err?.message || "Validation error. Please check your input.",
        type: "warning",
        confirmButtonColor: "#3085d6",
        confirmButtonText: "Ok",
        confirmButtonClass: "btn btn-primary",
        okButtonClass: "",
        buttonsStyling: 1,
      });
      return;
    }

    reCalculateSalaryMutate(payload, {
      onSuccess: (response) => {
        console.log("reCalculateSalary response", response);
        if (response?.response === true) {
          Swal.fire({
            type: "success",
            title: "Salary Updated!",
            text: response?.errorMessage || "Something went wrong",
            confirmButtonClass: "btn btn-success",
          }).then(function (t) {
            handleRefresh();
            // updateRowInState(record?.key, response?.data?.[0] || {});
            setTempMonthSalary({});
          });
        } else {
          Swal.fire({
            title: "Warning!",
            text: response?.errorMessage || "Something went wrong",
            type: "warning",
            confirmButtonColor: "#3085d6",
            confirmButtonText: "Ok",
            confirmButtonClass: "btn btn-primary",
            okButtonClass: "",
            buttonsStyling: 1,
          });
        }
      },
      onError: (error) => {
        Swal.fire({
          title: "Error!",
          text: error.message,
          type: "error",
          confirmButtonColor: "#3085d6",
          confirmButtonText: "Ok",
          confirmButtonClass: "btn btn-primary",
          okButtonClass: "",
          buttonsStyling: 1,
        });
      },
    });
  };

  const columns = [
    {
      title: "Emp Code",
      dataIndex: "uniqueID",
      key: "uniqueID",
    },
    {
      title: "Employee Name",
      dataIndex: "fullName",
      sorter: (a, b) => a.fullName.length - b.fullName.length,
      render: (text, record) => (
        <Link
          to={`${all_routes.employee}${all_routes.employee_view}/${record.employeeCode}`}
        >
          {text}
        </Link>
      ),
    },
    {
      title: "Month",
      dataIndex: "processMonth",
      // render: (text, record) => (
      //   <>
      //     {new Date(
      //       record.processYear,
      //       record.procesMonth - 1,
      //       1
      //     ).toLocaleString("default", { month: "short" })}
      //     - {record.processYear}
      //   </>
      // ),
    },
    {
      title: "Basic Salary",
      dataIndex: "basicSalary",
      sorter: (a, b) => a.basicSalary.length - b.basicSalary.length,

      render: (text, record, index) => (
        <div className="d-flex">
          {/* <input
            // {...register(`payrollData[${index}].updatedBasicSalary`)}
            name={`reportData[${record?.key}].updatedBasicSalary`}
            className="form-control payroll-input"
            defaultValue={text || ""}
            readOnly={false}
            style={{ width: "100px" }}
            onInput={(e) => {
              e.target.value = e.target.value.replace(/\D/g, "");
            }}
          /> */}
          <input
            className="form-control payroll-input"
            // defaultValue={text || ""}
            value={tempMonthSalary[index] ?? text ?? ""}
            style={{ width: "100px" }}
            onChange={(e) => {
              setTempMonthSalary((prev) => ({
                ...prev,
                [index]: e.target.value,
              }));
            }}
          />

          <button
            type="button"
            className="btn btn-default ms-1"
            onClick={() => reCalculateSalary(record, tempMonthSalary[index])}
            disabled={
              tempMonthSalary[index] === undefined ||
              tempMonthSalary[index] === "" ||
              isNaN(Number(tempMonthSalary[index]))
            }
            style={{ border: "none" }}
          >
            <span className="me-1 d-flex align-items-center">
              <RefreshCcw className="feather-16" size={12} />
            </span>
          </button>
        </div>
      ),
    },
    {
      title: "Addition",
      dataIndex: "addition",
      sorter: (a, b) => a.addition.length - b.addition.length,
      render: (text, record) => Number(text).toFixed(2),
    },
    {
      title: "Deduction",
      dataIndex: "deduction",
      sorter: (a, b) => a.deduction.length - b.deduction.length,
      render: (text, record) => Number(text).toFixed(2),
    },
    {
      title: "Employee Cpf",
      dataIndex: "employeeCpf",
      sorter: (a, b) => a.employeeCpf.length - b.employeeCpf.length,
      render: (text, record) => Number(text).toFixed(2),
    },
    {
      title: "Employer CPF",
      dataIndex: "employerCpf",
      sorter: (a, b) => a.employerCpf.length - b.employerCpf.length,
      render: (text, record) => Number(text).toFixed(2),
    },
    {
      title: "Total CPF",
      dataIndex: "totalCpf",
      sorter: (a, b) => a.totalCpf.length - b.totalCpf.length,
      render: (text, record) => Number(text).toFixed(2),
    },
    {
      title: "Net Pay",
      dataIndex: "netPay",
      sorter: (a, b) => a.netPay.length - b.netPay.length,
      render: (text, record) => Number(text).toFixed(2),
    },

    {
      title: "Pay Date",
      dataIndex: "paymentDate",
      width: "200px",
      render: (text, record, index) => (
        // <DatePicker
        //   name={`reportData[${record?.key}].paymentDate`}
        //   placeholder="Select Pay Date"
        //   value={
        //     record?.paymentDate
        //       ? dayjs(record.paymentDate, dateFormat)
        //       : dayjs() // ✅ default to today
        //   }
        //   format={dateFormat}
        //   className="form-control"
        //   onChange={(date) => updatePayDate(date, record, index)}
        //   // disabledDate={(current) =>
        //   //   current && current.isBefore(dayjs(), "day")
        //   // }
        //   style={{ width: "100%" }}
        //   allowClear={false}
        // />
        <StagingPayDate
          name={`reportData[${record?.key}].paymentDate`}
          placeholder="Select Pay Date"
          format={dateFormat}
          className="form-control"
          style={{ width: "100%" }}
          allowClear={false}
          record={record}
          setReportData={setReportData}
          index={index}
        />
      ),
    },
    {
      title: "Action",
      dataIndex: "action",
      className: "action-table-data",
      render: (text, record) => (
        <div className="edit-delete-action">
          <div className="input-block add-lists"></div>
          <Can
            accessModule={accessCodes.payroll_management}
            accessCode={accessCodes.payroll_processing_stages}
            accessType="haveEdit"
          >
            <Link
              className="me-2 p-2"
              to={`${all_routes.payroll}${all_routes.payroll_stage_view}/${record.refNo}`}
            >
              <Eye className="feather-edit" />
            </Link>

            {/* <Link
              className="me-2 p-2"
              // type="button"
              // onClick={() => showEditHandler(record)}
              to={`${all_routes.payroll}${all_routes.payroll_stage_edit}/${record.refNo}?returnUrl=${encodeURIComponent(
                `/Payroll/PayrollStage?month=${filter.month}&year=${filter.year}`,
              )}`}
            >
              <Edit className="feather-edit" />
            </Link> */}
            <Link
              type="button"
              className="me-2 p-2"
              // to={`${all_routes.payroll}${all_routes.payroll_stage_edit}/${record.refNo}`}
              onClick={() =>
                regeneratePayroll({
                  companyCode: record.companyCode,
                  refNo: record.refNo,
                  month: record.procesMonth.toString(),
                  year: record.processYear.toString(),
                  userCode: userData.userID,
                  locationCode: record.locationCode,
                  salaryType: record.salaryType,
                  employeeCode: record.employeeCode,
                })
              }
            >
              <RefreshCw className="feather-edit" />
            </Link>
          </Can>
        </div>
      ),
    },
  ];

  const searchColumns = columns.map((column, index) => column.dataIndex);
  const { searchValue, setSearchValue, filteredData } = useTableSearch(
    reportData,
    searchColumns,
  );

  const approvePayroll = () => {
    const selectedRows = reportData.filter((_, index) =>
      selectedRowKeys.includes(index),
    );

    const payload = selectedRows?.map((payroll) => ({
      ...payroll,
      companyCode: payroll.companyCode,
      locationCode: payroll.locationCode || userData.locationCode,
      refNo: payroll.refNo,
      employeeCode: payroll.employeeCode,
      icno: payroll.icno,
      processDateStr: format(new Date(), "yyyy-MM-dd"),
      advancePayment: Number(payroll.advancePayments),
      procesMonth: Number(payroll.procesMonth),
      processYear: Number(payroll.processYear),
      paymentCode: Number(payroll.paymentCode),
      departmentCode: Number(payroll.departmentCode),
      monthlySalary: Number(payroll.monthlySalary),
      basicSalary: Number(payroll.basicSalary),
      grossSalary: Number(payroll.grossSalary),
      addition: Number(payroll.addition),
      deduction: Number(payroll.deduction),
      totalCpf: Number(payroll.totalCpf),
      employeeCpf: Number(payroll.employeeCpf),
      employerCpf: Number(payroll.employerCpf),
      leaveTakenInDays: Number(payroll.leaveTakenInDays),
      leaveSalaryAmount: Number(payroll.leaveSalaryAmount),
      netPay: Number(payroll.netPay),
      contributionCode: payroll.contributionCode,
      agencyAmount: Number(payroll.agencyAmount),
      sdlAmount: Number(payroll.sdlAmount),
      noOfDaysInMonth: Number(payroll.noOfWorkingDays),
      noOfWorkingDays: Number(payroll.noOfWorkingDays),
      hourlySalary: Number(payroll.hourlySalary),
      additionalHours: Number(payroll.additionalHours),
      deductionHours: Number(payroll.deductionHours),
      otHourlySalary: Number(payroll.otHourlySalary),
      noOfOTWorkingDays: Number(payroll.noOfOtworkingDays),
      // otDaySalary: Number(payroll.otDaySalary),
      // otDaySalary: payroll.noOfOTWorkingDaysSalary,
      payrollValue: Number(payroll.payrollValue),
      createUser: userData.createUser,
      extraorlessHourAmount: Number(payroll.extraorlessHourAmount),
      daySalary: Number(payroll.daySalary),
      publicHolidayHours: payroll.publicHolidayHours,
      publicHolidayHoursSalary: payroll.publicHolidayHoursSalary,
      waitingTime: Number(payroll.waitingTime) ?? 0,
      waitingTimeSalary: Number(payroll.waitingTimeSalary) ?? 0,
      paidLeaveDays: payroll.paidLeaveDays,
      paidLeaveSalary: payroll.paidLeaveSalary,
      payrollDetail: payroll.payrollDetail || [],
      earningsList: payroll.earningsList || [],
      deductionList: payroll.deductionList || [],
      additionsList: payroll.additionsList || [],
      deductionsList: payroll.deductionsList || [],
      normalWorkingHoursInMonth: Number(payroll.normalWorkingHoursInMonth) || 0,
      normalWorkingHoursSalary: Number(payroll.normalWorkingHoursSalary) || 0,
      oT1Hours: Number(payroll.oT1Hours) || 0,
      oT1HourlySalary: Number(payroll.oT1HourlySalary) || 0,
      oT2Hours: Number(payroll.oT2Hours) || 0,
      oT2HourlySalary: Number(payroll.oT2HourlySalary) || 0,
      extraHours: Number(payroll.extraHours) || 0,
      extraHoursSalary: Number(payroll.extraHoursSalary) || 0,
      publicHolidayOTHours: Number(payroll.publicHolidayOTHours) || 0,
      publicHolidayOTHoursSalary:
        Number(payroll.publicHolidayOTHoursSalary) || 0,
      otDaySalary: Number(payroll.otdaySalary) || 0,
      levyAmount: Number(payroll.levyAmount) || 0,
      paymentDate: dayjs(payroll.paymentDate).format(dateFormat) || null,
    }));

    Swal.fire({
      title: "Confirm to submit?",
      text: "Are you sure you want submit payroll",
      type: "warning",
      showCancelButton: !0,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, submit it!",
      confirmButtonClass: "btn btn-primary",
      cancelButtonClass: "btn btn-danger ml-1",
      buttonsStyling: 1,
      buttons: ["Cancel", "Submit"],
    }).then(function (t) {
      if (t.isConfirmed) {
        payrollApprove(payload, {
          onSuccess: (response) => {
            if (response[0].response === true) {
              Swal.fire({
                type: "success",
                title: "Payroll Generated!",
                text: "Payroll Generated Successfully..",
                confirmButtonClass: "btn btn-success",
              }).then(function (t) {
                // navigate(`${all_routes.payroll}${all_routes.payroll_lits}`);
                setSelectedRowKeys([]);
                getReport();
              });
            } else {
              Swal.fire({
                title: "Warning!",
                text: response[0].errorMessage,
                type: "warning",
                confirmButtonColor: "#3085d6",
                confirmButtonText: "Ok",
                confirmButtonClass: "btn btn-primary",
                okButtonClass: "",
                buttonsStyling: 1,
              });
            }
          },
        });
      }
    });
  };

  const filterComponents = (
    <div className="form-row row" style={{ width: "50%" }}>
      <div className="col-lg-4 col-md-4 col-sm-6 col-12 mb-3">
        <div className="form-group">
          <label className="form-label">Month</label>
          <MonthOption
            selectedMonth={filter?.month}
            monthSelectHandler={monthSelectHandler}
          />
        </div>
      </div>
      <div className="col-lg-4 col-md-4 col-sm-6 col-12 mb-3">
        <div className="form-group">
          <label className="form-label">Year</label>
          <YearOption
            selectedYear={Number(filter?.year)}
            yearSelectHandler={yearSelectHandler}
          />
        </div>
      </div>
      <div className="col-lg-4 col-md-4 col-sm-6 col-12">
        <div className="input-blocks">
          <label className="form-label">&nbsp;</label>
          <Link
            className="btn btn-filters ms-auto"
            onClick={handleRefresh}
            type="button"
          >
            <i data-feather="search" className="feather-search" />
            {isFetching ? (
              <>
                <i className="fas fa-spinner fa-spin me-2"></i>
                Loading...
              </>
            ) : (
              <>Filter</>
            )}
          </Link>
        </div>
      </div>
    </div>
  );
  if (isFetching) return <LoadingSpinner />;
  if (isError) return <Error404 error={error} />;
  return (
    <>
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header">
            <div className="add-item d-flex">
              <div className="page-title">
                <h4>Payroll Staging Summary</h4>
                {/* <h6>Monthly Payroll Summary </h6> */}
              </div>
            </div>
            <div className="page-btn">
              <Can
                accessModule={accessCodes.payroll_management}
                accessCode={accessCodes.payroll_processing_stages}
                accessType="haveAdd"
              >
                <button
                  type="button"
                  className="btn btn-primary"
                  disabled={selectedRowKeys.length <= 0}
                  onClick={approvePayroll}
                >
                  Approve Payroll
                </button>
              </Can>
              &nbsp;
            </div>
            {selectedRowKeys.length > 0 && (
              <div className="page-btn">
                <Can
                  accessModule={accessCodes.payroll_management}
                  accessCode={accessCodes.payroll_processing_stages}
                  accessType="haveAdd"
                >
                  <button
                    type="button"
                    className="btn btn-primary"
                    disabled={selectedRowKeys.length <= 0}
                    onClick={() => setShowPaymentDateModal((prev) => !prev)}
                  >
                    Change Pay Date
                  </button>
                </Can>
                &nbsp;
              </div>
            )}
            <ReportTools
              columns={columns}
              data={reportData}
              fileName={`Monthly Payroll Staging Report ${filter.month} - ${filter.year}`}
              pdfTheme="striped"
              refresh={handleRefresh}
            />
          </div>

          <div className="card table-list-card border-0">
            <div className="card-body">
              <TableTop
                onSearch={setSearchValue}
                toggleFilterVisibility={toggleFilterVisibility}
                isFilterVisible={isFilterVisible}
                showToggle={false}
                otherProps={filterComponents}
              />

              <div className="table-responsive">
                <Table
                  rowSelection={rowSelection}
                  columns={columns}
                  dataSource={filteredData}
                  pagination={false}
                  rowKey={(record) => record.key}
                  size="middle"
                  // expandable={{
                  //   expandIconColumnIndex: 5, // 👈 shows expand button near first column (Emp Code)

                  //   expandedRowRender: (record) => {
                  //     return (
                  //       <div style={{ padding: "10px 20px" }}>
                  //         {/* {record.attendanceDetails.map((attendance, index) => ( */}
                  //           <div  style={{ marginBottom: 15 }}>

                  //             <table
                  //               style={{
                  //                 width: "auto",
                  //                 marginTop: 8,
                  //                 borderCollapse: "collapse",
                  //               }}
                  //               className="table table-bordered table-stripped text-center"
                  //             >
                  //               <thead>
                  //                 <tr>
                  //                   <th>Break In</th>
                  //                   <th>Break Out</th>
                  //                   <th>Break Hours</th>
                  //                 </tr>
                  //               </thead>
                  //               {/* <tbody>
                  //                 {attendance?.breakDetails?.length > 0 &&
                  //                   attendance.breakDetails?.map(
                  //                     (breakItem, i) => (
                  //                       <tr key={i}>
                  //                         <td>
                  //                           {moment(
                  //                             breakItem.breakInTime,
                  //                             "HH:mm",
                  //                           ).format("hh:mm A")}
                  //                         </td>
                  //                         <td>
                  //                           {breakItem.breakOutTime !== "-"
                  //                             ? moment(
                  //                                 breakItem.breakOutTime,
                  //                                 "HH:mm",
                  //                               ).format("hh:mm A")
                  //                             : "-"}
                  //                         </td>
                  //                         <td>{breakItem.breakHours}</td>
                  //                       </tr>
                  //                     ),
                  //                   )}
                  //               </tbody> */}
                  //             </table>
                  //           </div>
                  //         {/* ))} */}
                  //       </div>
                  //     );
                  //   },
                  // }}
                  // scroll={{
                  //   x: 1200,
                  //   y: 500, // Enables sticky header
                  // }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <Modal
        title="Payslip Details"
        show={isModalVisible}
        onCancel={handleCancel}
        footer={[
          <Button key="close" onClick={handleCancel}>
            Close
          </Button>,
        ]}
        width={1000}
      >
        {/* <Modal
        show={isModalVisible}
        onHide={handleCancel}
        animation={true}
        centered
        size="lg"
      > */}
        {selectedRowKeys?.map((selectedPayslip, key) => {
          return (
            <Payslip
              payslipDetails={reportData[selectedPayslip]}
              companyDetails={companyDetails}
              key={key}
            />
          );
        })}
      </Modal>

      <ChangeDate
        onSubmit={changePayDate}
        show={showPaymentDateModal}
        handleClose={() => setShowPaymentDateModal(false)}
        payDate={payDate}
        setPayDate={setPayDate}
      />

      <EditAdditionDeductionModal
        show={showEditModal}
        handleClose={closeEditModal}
        onSubmit={() => {}}
      />
    </>
  );
};

export default PayrollStaging;
